import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { DropdownSearchComponent } from './components/dropdown-search/dropdown-search.component';

@Component({
  selector: 'app-dropdown',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,

    // Components
    DropdownSearchComponent
  ],
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownComponent {
  changed = output<DropdownOptionValue>();

  options = input.required<DropdownOption[]>();

  activeValue = input<number>(0);

  title = computed(() => this.options()[this.activeValue() ?? 0]?.title)

  private _query = signal<string | null>(null);

  filteredOptions = computed(() => {
    const query = this._query()?.toLowerCase();

    return query
      ? this.options().filter(item => {
          const title = item.title.toLowerCase();

          return title.includes(query)
        })
      : this.options();
  })

  getQuery(value: string | null) {
    this._query.set(value)
  }
}

export interface DropdownOption<T = DropdownOptionValue> {
  title: string;
  value: T;
}

export type DropdownOptionValue = number | string;
